import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import Calculator from "../components/Calculator";
import { Link } from "react-router-dom";
import "react-circular-progressbar/dist/styles.css";
import CountData from "../components/CountData";
import Seo from "../components/Seo";
import Marquee from "react-fast-marquee";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

const HomePage = () => {
  const [blogDataDisplay, setBlogDataDisplay] = useState([]);
  const [productDataDisplay, setProductDataDisplay] = useState([]);
  const [categoriesDataDisplay, setCategoriesDataDisplay] = useState([]);

  // Slider Settings
  let settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    appendDots: (dots) => <ul style={{ marginTop: "0px" }}>{dots}</ul>,
    customPaging: (i) => <button>Slide {i + 1}</button>,
  };

let settingsnewww = {
  dots: false,
  infinite: true,
  speed: 6000,
  slidesToShow: 3,        // desktop
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",

  responsive: [
    {
      breakpoint: 768,     // below 768px = mobile
      settings: {
        slidesToShow: 1,   // mobile
        slidesToScroll: 1,
      }
    }
  ]
};


  const images = ["/assets/images/banner-2.png", "/assets/images/banner_3.png"];

  const settingsImg = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 800, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  // Fetch Blogs
  const getBlogData = async () => {
    try {
      const res = await axios.get(
        "https://test.bioversalremedies.com/bioversal_remedies_admin/api/get_blog"
      );
      const data = res.data.length > 3 ? res.data.slice(0, 3) : res.data;
      setBlogDataDisplay(data);
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch Products
  const getProductData = async () => {
    try {
      const res = await axios.get(
        `https://test.bioversalremedies.com/bioversal_remedies_admin/api/get_product`
      );

      const shuffled = res.data
        .map((item) => ({ item, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ item }) => item);

      const randomTen = shuffled.slice(0, 10);
      setProductDataDisplay(randomTen);
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch Categories
  const getCategoriesData = async () => {
    try {
      const res = await axios.get(
        "https://test.bioversalremedies.com/bioversal_remedies_admin/api/categories-data"
      );
      if (res.data.status) {
        setCategoriesDataDisplay(res.data.data);
      }
    } catch (error) {
      console.log("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    getBlogData();
    getProductData();
    getCategoriesData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo
        title="Top Pharma Franchise Company in India | Bioversal Remedies"
        description="Discover Bioversal Remedies – a top pharma franchise company in India offering monopoly-based PCD pharma franchise opportunities with quality medicines & support."
        type="webapp"
        name="Bioversal Remedies"
      />

      <div className="page-content bg-white">
        {/* Banner */}
        <Slider {...settings} style={{ height: "max-content" }}>
          {images.map((img, index) => (
            <div key={index}>
              <div
                className="main-banner banner-img"
                style={{ backgroundImage: `url(${img})` }}
              >
                <div className="container inner-content">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 animate__animated animate__fadeIn">
                      <h6 className="title-ext text-primary">BIOVERSAL REMEDIES</h6>
                      <h1 className="mainhead_bio">
                        YOUR MOST TRUSTED HEALTH SOURCE!
                      </h1>
                      <p className="mainhead_para">
                        Bioversal Remedies, a PCD Pharma Company is established with an aim
                        not just to provide medications to the patients but to rescue their
                        lives and uplift their wellbeing. Our product development talents
                        assist us in establishing a long-term growth platform.
                      </p>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-end animate__animated animate__fadeIn">
                      <form className="banner-formmain_1">
                        <h5>Send Enquiry</h5>
                        <input type="text" required placeholder="Full Name" />
                        <input type="email" required placeholder="Email" />
                        <input type="tel" required placeholder="Mobile No." />
                        <input type="text" required placeholder="Location" />
                        <textarea required placeholder="Your Message"></textarea>
                        <button>
                          <a className="form_subhd" href="#">
                            Submit
                          </a>
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        {/* About Section */}
        <div className="abt-section-main">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <img
                  className="abtimagehere1"
                  src="/assets/images/abtimgmain.png"
                  alt=""
                />
              </div>

              <div className="col-lg-6 right-textmain animate__animated animate__fadeIn">
                <p>About Us</p>
                <h3>Welcome to Bioversal Remedies | Best Pharma Franchise Company in India</h3>
                <h6>
  Bioversal Remedies is an emerging and developing{" "}
  <a href="/pcd-pharma-franchise-company/">PCD Pharma Franchise Company</a>{" "}
  operating ethically in various parts of India such as Haryana, Punjab,
  West-Bengal, Assam, Tamil Nadu, Maharashtra, Karnataka, Bihar and etc.
  assuring the quality of the products, also as a{" "}
  <a href="/indian-pcd-pharma-companies">Top Pharma Franchise Company</a>{" "}
  in PAN India, established with an aim to provide effective healthcare support
  to patients keeping in mind the affordability and quality of its products.
  Bioversal Remedies is one of the leading Indian Pharma Companies delivering
  quality medication trusted by professionals and patients. Understanding the
  meaning of best medical care, our experts constantly strive to come up with{" "}
  <a href="/product-list/">Top quality medicines</a> with solutions for medical
  services, that would be available to individuals of all age groups. Discover
  our wide range of products and learn more about the benefits on our website.
  Start your journey towards a healthier, happier life with{" "}
  <a href="/pcd-pharma-franchise">Bioversal Remedies</a> today.
</h6>


                <div className="abt_buttons-cont">
  {/* Know More button */}
  <Link to="/company-overview">
    <button className="btn1st">
      Know More <span><img src="/assets/images/Vector-arrow.png" alt="arrow" /></span>
    </button>
  </Link>

  {/* Download Product Glossary button */}
  <a
    href="/assets/images/Bioversal-Glossary.pdf"
    target="_blank"
    download
  >
    <button className="btn2nd">
      Download Product Glossary <span><img src="/assets/images/Vector-pdf.png" alt="pdf" /></span>
    </button>
  </a>
</div>

              </div>
            </div>
          </div>
        </div>

        {/* Pharma Franchise Section */}
        <div className="container py-5 bestpharma">
          <div className="text-center mb-5">
            <p className="text-uppercase text-orange fw-bold small">
              What makes Bioversal a unique healthcare unit?
            </p>
            <h2 className="fw-bold">Get Best Pharma Franchise deals!</h2>
          </div>

          <div className="row g-4 justify-content-center">
            {/* Card 1 */}
            <div className="col-md-4">
              <div className="p-4 shadow bg-white rounded h-100 text-center">
                <div className="mb-3">
                  <i className="fas fa-capsules fa-2x text-orange"></i>
                </div>
                <h5 className="fw-bold mb-3">Pharma Franchise</h5>
                <p className="text-tttt">
                 Bioversal Remedies aims to expand its network always. We are one of India’s leading PCD pharma company, offering pharma franchises and PCD pharma. If you’re seeking a pharma PCD, look no further. We provide the most appealing promotional benefits. Our philosophy is to give unsurpassed service and unbeatable prices to our customers, allowing them to improve their healthcare and wellbeing. We have a largest Pharmaceutical Distribution network in India.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-md-4">
              <div className="p-4 shadow bg-white rounded h-100 text-center">
                <div className="mb-3">
                  <i className="fas fa-hand-holding-medical fa-2x text-orange"></i>
                </div>
                <h5 className="fw-bold mb-3">Best PCD Pharma Franchise Company</h5>
                <p className="text-tttt">
                 What you should really expect when starting a business or as a franchise partner is; Today, as per the interest of prescription and pharma products, a pharma is going to meet the clinical fundamentals with the proficient pharmaceutical company. However, if you are a Pharma specialist, then this information will give you an idea about PCD Pharma companies. You have a choice to choose from while doing a pharmaceutical company.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-md-4">
              <div className="p-4 shadow bg-white rounded h-100 text-center">
                <div className="mb-3">
                  <i className="far fa-gem fa-2x text-orange"></i>
                </div>
                <h5 className="fw-bold mb-3">Quality Assurance</h5>
                <p className="text-tttt">
                 Nowadays, India's drug authorities are quite stringent, and all manufacturing units must adhere to the Schedule, which requires every manufacturer to fulfill all of India's drug authorities' standards. Quality being the prime work ethic of our business, we aim to lend superior quality medicines to our precious patients. We not only want to provide exceptional healthcare to our patients, but we also want to improve their quality of life for them.
                </p>
              </div>
            </div>
          </div>
        </div>

        <CountData />

        {/* Categories Slider */}
        <div className="biovers-med_main animate__animated animate__fadeIn">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <div className="row home_green_card_padding">
                  <div className="col-lg-6 main-med_head">
                    <h3>Bioversal Remedies - PCD Pharma Franchise</h3>
                    <h2>Best Pharma Franchise Company</h2>
                  </div>

                  <div className="col-lg-6 main-med_text">
                    <p>
                      Bioversal Remedies ensures people in need have access to high-quality, affordable medicines. Our solutions enable effectiveness and productivity in supply chain management and third-party Pharma manufacturing.
                    </p>
                  </div>
                </div>
              </div>

              <Slider className="borde medi-slidemain" {...settingsImg}>
                {categoriesDataDisplay.map((item, index) => {
                  const categorySlug = item.name
                    .toLowerCase()
                    .trim()
                    .replace(/ /g, "-")
                    .replace(/[^a-z0-9-]/g, "");

                  return (
                    <div className="slider-imgg_hmain" key={index}>
                      <Link to={`/categories/${categorySlug}`}>
                        <img
                          className="prod__uct_images"
                          src={item.image || "/assets/images/default.png"}
                          alt={item.name}
                        />
                        <p>{item.name}</p>
                      </Link>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>

        {/* Product Range */}
        <div className="prod-range_secmain">
          <div className="container-fluid medi-headingshere">
            <h4 className="range-subhead">HIGH QUALITY MEDICAL SUPPLIES</h4>
            <h2>We offer a wide range of products</h2>
          </div>

          <Slider {...settingsnewww}>
            {productDataDisplay.map((item) => (
              <div key={item.id} className="prod-item">
                <Link to="/product-list">
                  <div
                    className="prod-img-conthmain"
                    style={{ cursor: "pointer", padding: "10px" }}
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{
                        height: "500px",
                        borderRadius: "10px",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                    <div className="hover-texthm1">
                      <p>{item.name}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>

          <div className="bot-marquee_phar">
            <Marquee>
              <p className="pharma_announce">
                Pharma Franchise + PCD Pharma + Healthcare +
              </p>
            </Marquee>
          </div>
        </div>

        <Calculator />

        {/* Blog Section */}
        <div className="blog_section-here">
          <div className="container-fluid medi-headingshere">
            <h4 className="range-subhead">HEALTH ESSENTIALS</h4>
            <h2>LET US READ WHAT'S NEW</h2>
          </div>

       <div className="container mb-5">
  <div className="row blog_main">
    {blogDataDisplay.map((item) => (
 <div key={item.id} className="col-lg-4 col-md-6 col-sm-12 mb-4">
  <div className="card card-shadow w-100">
    {/* Image */}
    <div className="card-header position-relative">
      <img
        src={item.image}
        alt={item.title}
        className="img-fluid rounded-top"
      />
      {/* Optional arrow on top-right */}
      <div className="link-arrowmain position-absolute" style={{ top: "10px", right: "10px" }}>
        <Link to={`/${item.slug}/`}>
          <img src="assets/images/link_arrow.png" alt="Read More" />
        </Link>
      </div>
    </div>

    {/* Body */}
    <div className="card-body" style={{ minHeight: "250px" }}>
      {/* Date */}
      {item.created_at && (
        <div className="card-date mb-2">
          <small>{new Date(item.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</small>
        </div>
      )}

      {/* Title */}
      <div
        className="card-title mb-2"
        style={{
          fontSize: "20px",
          fontWeight: "600",
          color: "#004960",
          lineHeight: 1.2,
          borderBottom: "2px solid #F28535",
          padding: "5px 0",
        }}
      >
        {item.title}
      </div>

      {/* Description */}
      {item.description_front && (
        <div className="card-description">
          {item.description_front.slice(0, 150) + "..."}
        </div>
      )}
    </div>

    {/* Footer */}
    <div className="card-footer">
      <div className="d-flex justify-content-end">
        <Link to={`/${item.slug}/`}>
          <div className="btn btn_read_more">Read More</div>
        </Link>
      </div>
    </div>
  </div>
</div>

    ))}
  </div>
</div>

        </div>

        {/* ⭐ Google Maps Section */}
        <div className="map-section mb-5">
          <div className="container">
            <div className="map-responsive">
			
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11589.939413811986!2d76.85300636006235!3d30.273854322311887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fb5cca03a3def%3A0xe02acd386d9ff807!2sBioversal%20Remedies%20pvt%20Ltd!5e0!3m2!1sen!2sin!4v1763714575642!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Bioversal Remedies Location"
              ></iframe>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default HomePage;
